/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactsEmailTransactionsSendErrorsResponseData,
  GetContactsEmailTransactionsSendErrorsResponseDataFromJSON,
  GetContactsEmailTransactionsSendErrorsResponseDataFromJSONTyped,
  GetContactsEmailTransactionsSendErrorsResponseDataToJSON
} from './GetContactsEmailTransactionsSendErrorsResponseData'

/**
 *
 * @export
 * @interface GetContactsEmailTransactionsSendErrorsResponse
 */
export interface GetContactsEmailTransactionsSendErrorsResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactsEmailTransactionsSendErrorsResponse
   */
  status?: number
  /**
   *
   * @type {GetContactsEmailTransactionsSendErrorsResponseData}
   * @memberof GetContactsEmailTransactionsSendErrorsResponse
   */
  data?: GetContactsEmailTransactionsSendErrorsResponseData
}

export function GetContactsEmailTransactionsSendErrorsResponseFromJSON(
  json: any
): GetContactsEmailTransactionsSendErrorsResponse {
  return GetContactsEmailTransactionsSendErrorsResponseFromJSONTyped(json, false)
}

export function GetContactsEmailTransactionsSendErrorsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactsEmailTransactionsSendErrorsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactsEmailTransactionsSendErrorsResponseDataFromJSON(json['data'])
  }
}

export function GetContactsEmailTransactionsSendErrorsResponseToJSON(
  value?: GetContactsEmailTransactionsSendErrorsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactsEmailTransactionsSendErrorsResponseDataToJSON(value.data)
  }
}
